module.exports = __webpack_public_path__ + "static/media/exactValueTriangle2.b2fccc46.svg";